<template>
  <o-section
    :level="level + 1"
    :title="label || schema.verbose_name"
    body-classes="p-0"
    not-closable
  >
    <o-item-editable-table
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
      v-model="items"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'type')">{{ schema.fields.type.label }}</th>
        <th v-if="canSee(schema, 'username')">
          {{ schema.fields.username.label }}
        </th>
        <th v-if="canSee(schema, 'password')">
          {{ schema.fields.password.label }}
        </th>
        <th v-if="canSee(schema, 'note')">{{ schema.fields.note.label }}</th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'type')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="type"
          >
            <o-select
              :form-state="formState"
              :items="optionCodeLoginTypeItems"
              :loading="optionCodeLoginTypeWorking"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              add-title="Create New"
              allow-add
              name="type"
              nolabel
              sort-field="description"
              store-name="CodeLoginType"
              text-field="description"
              v-bind="schema.fields.type"
              v-model="items[index].type"
              value-field="id"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <code-login-type-form
                  :form-state="formState"
                  :item="item"
                  :server-errors="serverErrors"
                  in-modal
                ></code-login-type-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'username')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="username"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="username"
              nolabel
              v-bind="schema.fields.username"
              v-model="items[index].username"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'password')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="password"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="password"
              nolabel
              v-bind="schema.fields.password"
              v-model="items[index].password"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'note')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="note"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="note"
              nolabel
              v-bind="schema.fields.note"
              v-model="items[index].note"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";

export default {
  name: "ProjectLoginFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("ProjectLogin"),
    CreateCodeTableFetchMixin(["CodeLoginType"]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.ProjectLogin,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.ProjectLogin),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>
